import { useQuery } from '@tanstack/react-query';
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
} from 'recharts';
import { api } from '../../lib/api.js';
import { ErrorBoundary } from '../ErrorBoundary.js';

function Chart() {
  const { data, isLoading } = useQuery({
    queryKey: ['sessions-over-time'],
    queryFn: () => api.getSessionsOverTime(30),
    refetchInterval: 5 * 60_000,
  });

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-48 text-sm text-text-dimmed">
        Loading…
      </div>
    );
  }

  const points = (data?.data ?? []).map((d) => ({
    ...d,
    label: d.date.slice(5),
  }));

  return (
    <div>
      <div className="text-xs font-semibold uppercase tracking-widest text-text-secondary mb-4">
        Sessions · 30 days
      </div>
      <ResponsiveContainer width="100%" height={200}>
        <BarChart data={points} barCategoryGap="20%">
          <XAxis
            dataKey="label"
            tick={{ fill: 'var(--text-dimmed)', fontSize: 10 }}
            tickLine={false}
            axisLine={false}
            interval={4}
          />
          <YAxis
            tick={{ fill: 'var(--text-dimmed)', fontSize: 10 }}
            tickLine={false}
            axisLine={false}
            allowDecimals={false}
          />
          <Tooltip
            contentStyle={{
              background: 'rgba(14,58,68,0.95)',
              border: '1px solid rgba(13,207,184,0.25)',
              borderRadius: 8,
              fontSize: 12,
              color: '#f0fafa',
            }}
            formatter={(value, name) => [value, name]}
            labelFormatter={(label) => `Date: ${label}`}
          />
          <Legend
            wrapperStyle={{ fontSize: 11, color: 'var(--text-secondary)' }}
          />
          <Bar dataKey="completed" name="Completed" stackId="a" fill="#0dcfb8" radius={[0, 0, 0, 0]} />
          <Bar dataKey="failed" name="Failed" stackId="a" fill="#ee5d50" radius={[3, 3, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}

export function SessionsChart() {
  return (
    <div
      className="glass rounded-2xl p-5"
      style={{ boxShadow: '0 3px 20px rgba(0,0,0,0.3)' }}
    >
      <ErrorBoundary>
        <Chart />
      </ErrorBoundary>
    </div>
  );
}
